import tools from '../emergency-tools.json';

export const isEmergencyMode = typeof __EMERGENCY_MODE__ !== 'undefined' && __EMERGENCY_MODE__;
export const emergencyToolNames = [...tools.map(tool => tool.name), 'crayon'];
export const isToolAllowed = name => !isEmergencyMode || emergencyToolNames.includes(name);
